import { render, staticRenderFns } from "./ChangeTimeDurationDropdown.vue?vue&type=template&id=5263af80"
import script from "./ChangeTimeDurationDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeTimeDurationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports